import { Link } from 'react-router-dom';
import { Database } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const iconClass = 'inline-flex shrink-0 items-center gap-0.5 rounded text-primary hover:text-primary/75 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary';

export default function ServerSqlLinks({ hostname, instances = [] }) {
  if (instances.length === 0) return null;

  if (instances.length === 1) {
    const instance = instances[0];
    const label = `Ver motor SQL Server: ${instance.display_name}`;
    return (
      <Link to={`/assets/sql/${instance.id}`} className={iconClass} title={label} aria-label={label}>
        <Database className="h-3.5 w-3.5" strokeWidth={1.5} />
      </Link>
    );
  }

  const label = `Ver instancias SQL Server de ${hostname}`;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={iconClass} title={label} aria-label={label}>
          <Database className="h-3.5 w-3.5" strokeWidth={1.5} />
          <span className="text-xs">{instances.length}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuLabel>Instancias SQL Server</DropdownMenuLabel>
        {instances.map(instance => (
          <DropdownMenuItem key={instance.id} asChild>
            <Link to={`/assets/sql/${instance.id}`} className="cursor-pointer">
              {instance.display_name}
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
